import Phaser from 'phaser';
import BootScene from './scenes/BootScene';
import MenuScene from './scenes/MenuScene';
import GameScene from './scenes/GameScene';
import UIScene from './scenes/UIScene';
import { SCREEN, RENDER, PHYSICS } from './configs/GameConfig';

/**
 * Big Blue Ball - Game Configuration
 * 
 * Uses centralized configuration from GameConfig.js
 * Optimized for frame-rate independence (30-200+ FPS)
 * Anti-jitter physics configuration
 */
const config = {
    type: Phaser.AUTO,
    width: SCREEN.WIDTH,
    height: SCREEN.HEIGHT,
    parent: 'game-container',
    backgroundColor: SCREEN.BACKGROUND_COLOR,
    physics: {
        default: 'matter',
        matter: {
            debug: false,
            gravity: { y: PHYSICS.GRAVITY },
            // Fixed timestep for consistent physics across all frame rates
            runner: {
                isFixed: true,
                delta: PHYSICS.FIXED_TIMESTEP
            },
            // Solver iterations for stable physics
            positionIterations: PHYSICS.POSITION_ITERATIONS,
            velocityIterations: PHYSICS.VELOCITY_ITERATIONS,
            constraintIterations: PHYSICS.CONSTRAINT_ITERATIONS,
            // Timing
            timing: {
                timestamp: 0,
                timeScale: 1
            },
            // Enable sleeping for performance (bodies at rest sleep)
            enableSleeping: false  // Disabled to prevent ball "sticking"
        }
    },
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH
    },
    // Frame rate settings
    fps: {
        target: RENDER.TARGET_FPS,
        min: RENDER.MIN_FPS,
        forceSetTimeOut: false  // Use rAF for V-Sync
    },
    render: {
        antialias: RENDER.ANTIALIAS,
        pixelArt: RENDER.PIXEL_ART,
        roundPixels: RENDER.ROUND_PIXELS,
        transparent: false,
        batchSize: RENDER.BATCH_SIZE
    },
    scene: [BootScene, MenuScene, GameScene, UIScene]
};

const game = new Phaser.Game(config);

// Load and apply saved settings on startup
try {
    const savedSettings = localStorage.getItem('bigblueball_settings');
    if (savedSettings) {
        const settings = JSON.parse(savedSettings);
        
        // Apply FPS setting
        if (settings.targetFPS !== undefined) {
            if (settings.targetFPS === 0) {
                game.loop.targetFps = 1000;  // Unlimited
            } else {
                game.loop.targetFps = settings.targetFPS;
            }
        }
        
        // Apply V-Sync setting
        if (settings.vsyncEnabled !== undefined) {
            game.loop.forceSetTimeOut = !settings.vsyncEnabled;
        }
    }
} catch (e) {
    console.log('Could not load settings on startup');
}

// Expose game instance for settings access
window.phaserGame = game;

